import { Navigate, useLocation } from 'react-router-dom'

/** `/admin/instructions/...` → `/instructions/...` с тем же хвостом и параметрами. */
export const LegacyInstructionsRedirect = () => {
  const { pathname, search, hash } = useLocation()
  const to = pathname.replace(/^\/admin\/instructions/, '/instructions') + search + hash
  return <Navigate to={to} replace />
}
